<template>
  <div>
    <el-tabs type="border-card" stretch>
      <el-tab-pane label="Functional activity spectrum profiling">
        <span slot="label" class="fontClass">Functional activity spectrum profiling</span>
        <div class="my-container">
          <h2>1. Functional activity spectrum profiling</h2>
        </div>
        <div style="text-align: left">
<!--          <h2>Activity of Angiogenesis and associated gene repertories across all cancer types</h2>-->
          <div class="RadioBox">
            <el-radio-group v-model="cancer_type" @change="chooseFunctionState">
              <el-radio :label="1" border size="medium" class="RadioItem1"><span style="font-size: 16px">Angiogenesis</span></el-radio>
              <el-radio :label="2" border size="medium" class="RadioItem1"><span style="font-size: 16px">Apoptosis</span></el-radio>
              <el-radio :label="3" border size="medium" class="RadioItem1"><span style="font-size: 16px">CellCycle</span></el-radio>
              <el-radio :label="4" border size="medium" class="RadioItem1"><span style="font-size: 16px">Differentiation</span></el-radio>
              <el-radio :label="5" border size="medium" class="RadioItem1"><span style="font-size: 16px">DNADamage</span></el-radio>
              <el-radio :label="6" border size="medium" class="RadioItem1"><span style="font-size: 16px">DNARepair</span></el-radio>
              <el-radio :label="7" border size="medium" class="RadioItem1"><span style="font-size: 16px">EMT</span></el-radio>
              <br/>
              <el-radio :label="8" border size="medium" class="RadioItem1"><span style="font-size: 16px">Hypoxia</span></el-radio>
              <el-radio :label="9" border size="medium" class="RadioItem1"><span style="font-size: 16px">Inflammation</span></el-radio>
              <el-radio :label="10" border size="medium" class="RadioItem1"><span style="font-size: 16px">Invasion</span></el-radio>
              <el-radio :label="11" border size="medium" class="RadioItem1"><span style="font-size: 16px">Metastasis</span></el-radio>
              <el-radio :label="12" border size="medium" class="RadioItem1"><span style="font-size: 16px">Proliferation</span></el-radio>
              <el-radio :label="13" border size="medium" class="RadioItem1"><span style="font-size: 16px">Quiescence</span></el-radio>
              <el-radio :label="14" border size="medium" class="RadioItem1"><span style="font-size: 16px">Stemness</span></el-radio>
            </el-radio-group>
          </div>
          <h3>Activity of {{cancer_type_dic[cancer_type]}} across all cancer types</h3>
          <el-table
              :data="tableData"
              stripe
              :row-style="{height: '20px'}"
              :cell-style="{padding: '0', color: 'black', margin: '0'}"
              :header-cell-style="{padding: '0', margin: '0', fontSize: '16px', color: 'black'}">
            <el-table-column prop="Cancer" label="Cancer" width="200"/>
            <el-table-column prop="Name" label="Name" width="400"/>
            <el-table-column prop="No cells" label="No.cells" width="100"/>
            <el-table-column prop="FunctionalActivitySpectrum" label="Functional activity spectrum" min-width="50%" >
              <!-- 图片的显示 -->
              <template   slot-scope="scope">
                <!--            <div>{{scope.row}}</div>-->
                <img :src=mypic_list[scope.row.id-1] alt="" width="100%" height="30px"/>
                <!--            <img :src=img_test alt=""/>-->
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Cell type composition statistics">
        <span slot="label" class="fontClass">Cell type composition statistics</span>
        <div class="my-container">
          <h2>2. Cell type composition statistics</h2>
        </div>
        <div class="my-container">
          <div id="celltype_composition_echart" style="height: 600px; width: 1200px"/>
        </div>
        <div class="my-container">
          <div id="cancer_composition_echart" style="height: 600px; width: 1200px"/>
        </div>
        <h3>Grouped list of cell types</h3>
        <div style="text-align: left">
          <ul>
            <li>Epithelial Cells (7): Pancreatic acinar cell, Ductal cell, Epithelial, Hepatic progenitor cell, Keratinocytes, Melanocytes, Malignant</li>
            <li>Immune Cells (15):B cell, CD4Tconv, CD8T, CD8Tex, DC, Mast, NK, Mono_Macro, Treg, Tprolif, Plasmablasts, PVL, T_cells, DC, Myeloid</li>
            <li>Stromal Cells (6): Fibroblasts, Myofibroblasts, Endothelial, SMC, CAFs, Endometrial stromal cells</li>
            <li>Nervous System Cells (2): Neurons, Oligodendrocyte</li>
          </ul>
        </div>
        <div class="my-container" style="display: flex">
          <div id="grouped_celltype_celltype_composition_echart" style="height: 600px; width: 600px"/>
          <div id="grouped_celltype_cancer_composition_echart" style="height: 600px; width: 600px"/>
        </div>
      </el-tab-pane>
      <el-tab-pane label="TLS analysis">
        <span slot="label" class="fontClass">TLS analysis</span>
        <div class="my-container">
          <h2>3. TLS analysis</h2>
          <h3>TLS spot number statistics</h3>
          <el-table
              :data="TLS_table_data"
              stripe
              height="400"
              size="mini"
              show-summary
              style="margin: 0 auto; width: 50%">
            <el-table-column
                prop="Type"
                label="type"
                width="180">
            </el-table-column>
            <el-table-column
                prop="spots"
                label="spots">
            </el-table-column>
            <el-table-column
                prop="TLS"
                label="TLS">
            </el-table-column>
            <el-table-column
                prop="Non-TLS"
                label="Non-TLS">
            </el-table-column>
          </el-table>
          <h3>TLS group cell type scoring statistics</h3>
          <el-row>
            <TLSCardViolin2 v-for="i in TLS_card_violin" :cardID="i" :key="'TLSCardViolin'+i.toString()" @remove_father="remove_son_violin(i)"/>
            <el-col :span="12">
              <el-card :body-style="{ padding: '5px', height: '700px' }">
                <div style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center;">
                  <button class="circle_btn" @click="add_violin"><span style="font-size: 50px; font-weight: lighter">+</span> </button>
                </div>
              </el-card>
            </el-col>
          </el-row>
          <h3>TLS score & Celltype AddModuleScore multi-dataset comparison</h3>
          <el-row  v-if="TLS_card">
            <TLSCard v-for="i in TLS_card" :cardID="i" :key="'TLSCard'+i.toString()" @remove_father="remove_son(i)"/>
<!--            <el-col :span="8">-->
<!--              <el-card :body-style="{ padding: '5px', height: '500px' }">-->
<!--                <div style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center;">-->
<!--                  <button class="circle_btn" @click="add"><span style="font-size: 50px; font-weight: lighter">+</span> </button>-->
<!--                </div>-->
<!--              </el-card>-->
<!--            </el-col>-->
            <ImmuneComponentCard v-for="i in TLS_card_immune" :cardID="i" :key="i" @remove_father="remove_son_immune(i)"/>
            <el-col :span="8">
              <el-card :body-style="{ padding: '5px', height: '500px' }">
                <div style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center;">
                  <button class="circle_btn" @click="add_immune"><span style="font-size: 50px; font-weight: lighter">+</span> </button>
                </div>
              </el-card>
            </el-col>
          </el-row>
<!--          <el-row  v-if="TLS_card_immune">-->
<!--            <ImmuneComponentCard v-for="i in TLS_card_immune" :cardID="i" :key="i" @remove_father="remove_son_immune(i)"/>-->
<!--            <el-col :span="8">-->
<!--              <el-card :body-style="{ padding: '5px', height: '500px' }">-->
<!--                <div style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center;">-->
<!--                  <button class="circle_btn" @click="add_immune"><span style="font-size: 50px; font-weight: lighter">+</span> </button>-->
<!--                </div>-->
<!--              </el-card>-->
<!--            </el-col>-->
<!--          </el-row>-->
        </div>
      </el-tab-pane>
      <el-tab-pane label="TLS analysis">
        <span slot="label" class="fontClass">cell-cell interaction</span>
      </el-tab-pane>
    </el-tabs>


  </div>
</template>

<script>
import tableDataJson from '../../assets/PanCancer/cancerStateJson.json'
import cellTypeJson from '../../assets/PanCancer/cellTypeCompositionJson.json'
import img from '../../assets/PanCancer/cancerStateJs'
import * as echarts from 'echarts/core';
import {
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent
} from 'echarts/components';
import { BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import TLSCard from "@/components/tools/TLSCard";
// import TLSCardViolin from "@/components/tools/TLSCardViolin";
import TLSCardViolin2 from "@/components/tools/TLSCardViolin2";
import ImmuneComponentCard from "@/components/tools/ImmuneComponentCard";
echarts.use([
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BarChart,
  CanvasRenderer
]);

export default {
  name: "PanCancer",
  components: {ImmuneComponentCard, TLSCardViolin2, TLSCard},
  data() {
    return {
      cancer_type_dic: {
        1: 'Angiogenesis',
        2: 'Apoptosis',
        3: 'CellCycle',
        4: 'Differentiation',
        5: 'DNADamage',
        6: 'DNARepair',
        7: 'EMT',
        8: 'Hypoxia',
        9: 'Inflammation',
        10: 'Invasion',
        11: 'Metastasis',
        12: 'Proliferation',
        13: 'Quiescence',
        14: 'Stemness'
      },
      cancer_type: 1,
      tableData: [],
      materialpalette_color: ['#FF0000', '#FFC0CB', '#A020F0', '#673AB7', '#3F51B5', '#2196F3', '#03A9F4', '#00BCD4', '#009688',
          '#4CAF50', '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800', '#FF5722', '#795548', '#9E9E9E', '#607D8B'],
      materialpalette_color30: [
        '#FF0000', '#FF1493', '#FFC0CB', '#DB7093',
        '#B03060', '#DA70D6', '#FF00FF', '#A020F0',
        '#673AB7', '#3F51B5', '#0000CD', '#2196F3',
        '#03A9F4', '#00BCD4', '#009688', '#4CAF50',
        '#8BC34A', '#00FF00', '#54FF9F', '#C0FF3E',
        '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800',
        '#FF5722', '#795548', '#9E9E9E', '#607D8B',
        '#696969', '#1C1C1C'],
      ggsci_igv_color: ['#5050FFFF','#CE3D32FF','#749B58FF','#F0E685FF','#466983FF','#BA6338FF','#5DB1DDFF',
        '#802268FF','#6BD76BFF','#D595A7FF','#924822FF','#837B8DFF','#C75127FF','#D58F5CFF',
        '#7A65A5FF','#E4AF69FF','#3B1B53FF','#CDDEB7FF','#612A79FF','#AE1F63FF','#E7C76FFF',
        '#5A655EFF','#CC9900FF','#99CC00FF','#A9A9A9FF','#CC9900FF','#99CC00FF','#33CC00FF',
        '#00CC33FF','#00CC99FF','#0099CCFF','#0A47FFFF','#4775FFFF','#FFC20AFF','#FFD147FF',
        '#990033FF','#991A00FF','#996600FF','#809900FF','#339900FF','#00991AFF','#009966FF',
        '#008099FF','#003399FF','#1A0099FF','#660099FF','#990080FF','#D60047FF','#FF1463FF',
        '#00D68FFF','#14FFB1FF'],
      mypic: img.data().cancerStatePic,
      mypic_list: [],
      TLS_pic: img.data().TLS,
      img_test: require("@/assets/PanCancer/Angiogenesis/Angiogenesis-ASHN_GSE227469.png"),
      cellTypeData: {},
      cancerData: {},
      cellTypeDataKeys: [],
      cancerDataKeys: [],
      groupedCellTypeData: {},
      groupedCancerData: {},
      groupedCellTypeDataKeys: [],
      groupedCancerDataKeys: [],
      TLS_value: 'BLCA_GSE171351',
      TLS_options: ["BLCA_GSE171351", "BRCA_GSE176078", "BRCA_SpatialResearch", "BRCA_DCIS_IDC_section_WTA", "BRCA_her2st", "CECA_10X_CC", "CRC_CRLM", "CRC_IC_WTA", "GBM_10X_WTA", "MELA_SpatialResearch", "OVCA_OC_WTA", "PDAC_GSE111672", "PRCA_SpatialResearch", "PRCA_ACC_AIC_ANS", "SCC_GSE144240"],
      TLS_choose: 1,
      TLS_choose_pic: '',
      TLS_type_dic: {
        1: 'Angiogenesis',
        2: 'Apoptosis',
        3: 'CellCycle',
        4: 'Differentiation',
        5: 'DNADamage',
        6: 'DNARepair',
        7: 'EMT',
        8: 'Hypoxia',
        9: 'Inflammation',
        10: 'Invasion',
        11: 'Metastasis',
        12: 'Proliferation',
        13: 'Quiescence',
        14: 'Stemness'
      },
      TLS_table_data: [],
      TLS_card: [0],
      TLS_card_no: 2,
      TLS_card_immune: [0],
      TLS_card_immune_no: 2,
      TLS_card_violin: [0],
      TLS_card_violin_no: 1,
    }
  },
  mounted() {
    this.tableData = tableDataJson.tableData
    // console.log(tableDataJson)
    this.chooseFunctionState()
    this.chooseTLS()
    this.cellTypeData = cellTypeJson.divideByCellTypePercentage
    this.cellTypeDataKeys = Object.keys(this.cellTypeData)
    this.cancerData = cellTypeJson.divideByCancerTypePercentage
    this.cancerDataKeys = Object.keys(this.cancerData)
    this.groupedCellTypeData = cellTypeJson.GroupedCellTypeDivideByCellTypePercentage
    this.groupedCellTypeDataKeys = Object.keys(this.groupedCellTypeData)
    this.groupedCancerData = cellTypeJson.GroupedCellTypeDivideByCancerTypePercentage
    this.groupedCancerDataKeys = Object.keys(this.groupedCancerData)
    this.TLS_table_data = cellTypeJson.TLS_tableData
    // console.log(this.cellTypeDataKeys)
    // console.log(this.cancerDataKeys)
    this.$nextTick( () => {
      this.initCellTypeCompositionEcharts()
      this.initCancerCompositionEcharts()
      this.initGroupedCellTypeCompositionEcharts()
      this.initGroupedCancerCompositionEcharts()
    })
  },
  methods: {
    initCellTypeCompositionEcharts(){
      const chartDom = document.getElementById('celltype_composition_echart');
      const myChart = echarts.init(chartDom);
      let option;
      const mySeries = [];
      let keys = this.cancerDataKeys
      for(let i=0; i < keys.length; i++){
        let series_temp = {
              name: keys[i],
              type: 'bar',
              stack: 'total',
              // label: {
              //   show: true
              // },
              emphasis: {
                focus: 'series'
              },
              data: this.cancerData[keys[i]]
            }
        mySeries.push(series_temp)
      }

      // console.log(mySeries)
      option = {
        color: this.materialpalette_color,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {
          textStyle:{
            fontSize: '18px',
          }
        },
        grid: {
          left: '8%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.cellTypeDataKeys,
          axisLabel: {
            //x轴文字的配置
            show: true,
            interval: 0,//使x轴文字显示全
            rotate: 45,
            textStyle: {
              color: '#000000',
              fontSize: 14
            },
            // formatter: function(value) {
            //   return value.split('').join('\n')
            // }
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 1,
          boundaryGap: ['30%', '30%'],
        },
        series: mySeries
      };
      option && myChart.setOption(option);

    },
    initCancerCompositionEcharts(){
      const chartDom = document.getElementById('cancer_composition_echart');
      const myChart = echarts.init(chartDom);
      let option;
      const mySeries = [];
      let keys = this.cellTypeDataKeys
      for(let i=0; i < keys.length; i++){
        let series_temp = {
          name: keys[i],
          type: 'bar',
          stack: 'total',
          // label: {
          //   show: true,
          //   fontSize: 16,
          // },
          emphasis: {
            focus: 'series'
          },
          data: this.cellTypeData[keys[i]]
        }
        mySeries.push(series_temp)
      }

      // console.log(mySeries)
      option = {
        color: this.materialpalette_color30,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {
          textStyle:{
            fontSize: '18px',
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          top: '18%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.cancerDataKeys,
          axisLabel: {
            textStyle: {
              color: '#000000',
              fontSize: 14
            },
            // formatter: function(value) {
            //   return value.split('').join('\n')
            // }
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 1,
        },
        series: mySeries
      };
      option && myChart.setOption(option);

    },
    initGroupedCellTypeCompositionEcharts(){
      const chartDom = document.getElementById('grouped_celltype_celltype_composition_echart');
      const myChart = echarts.init(chartDom);
      let option;
      const mySeries = [];
      let keys = this.groupedCancerDataKeys
      for(let i=0; i < keys.length; i++){
        let series_temp = {
          name: keys[i],
          type: 'bar',
          stack: 'total',
          // label: {
          //   show: true
          // },
          emphasis: {
            focus: 'series'
          },
          data: this.groupedCancerData[keys[i]]
        }
        mySeries.push(series_temp)
      }

      // console.log(mySeries)
      option = {
        color: this.materialpalette_color,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {
          textStyle:{
            fontSize: '18px',
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.groupedCellTypeDataKeys,
          axisLabel: {
            //x轴文字的配置
            show: true,
            interval: 0,//使x轴文字显示全
            rotate: 45,
            textStyle: {
              color: '#000000',
              fontSize: 14
            },
            // formatter: function(value) {
            //   return value.split('').join('\n')
            // }
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 1,
          boundaryGap: ['30%', '30%'],
        },
        series: mySeries
      };
      option && myChart.setOption(option);

    },
    initGroupedCancerCompositionEcharts(){
      const chartDom = document.getElementById('grouped_celltype_cancer_composition_echart');
      const myChart = echarts.init(chartDom);
      let option;
      const mySeries = [];
      let keys = this.groupedCellTypeDataKeys
      for(let i=0; i < keys.length; i++){
        let series_temp = {
          name: keys[i],
          type: 'bar',
          stack: 'total',
          // label: {
          //   show: true
          // },
          emphasis: {
            focus: 'series'
          },
          data: this.groupedCellTypeData[keys[i]]
        }
        mySeries.push(series_temp)
      }

      // console.log(mySeries)
      option = {
        color: this.materialpalette_color,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {
          textStyle:{
            fontSize: '18px',
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.groupedCancerDataKeys,
          axisLabel: {
            show: true,
            interval: 0,//使x轴文字显示全
            rotate: 45,
            textStyle: {
              color: '#000000',
              fontSize: 14
            },
            // formatter: function(value) {
            //   return value.split('').join('\n')
            // }
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 1,
        },
        series: mySeries
      };
      option && myChart.setOption(option);

    },
    countPercentage(countArray){
      var j = 0;
      for (let i = 0 ; i < countArray.length ; i++){
        j = j + countArray[i];
      }
      console.log(countArray)
      console.log(j)
      const resultArray = [];
      for (let i = 0 ; i < countArray.length ; i++){
        const k = countArray[i] / j;
        resultArray.push(k);
      }
      return resultArray;
    },
    chooseFunctionState(){
      this.mypic_list = this.mypic[[this.cancer_type_dic[this.cancer_type]]]
    },
    chooseTLS(){
      this.TLS_choose_pic = this.TLS_pic[[this.TLS_value]][this.TLS_choose-1]
    },
    add(){
      this.TLS_card.push(this.TLS_card_no);
      this.TLS_card_no = this.TLS_card_no + 1
    },
    remove_son(i){
      this.TLS_card = this.TLS_card.filter(item => item !== i);
    },
    add_violin(){
      this.TLS_card_violin.push(this.TLS_card_violin_no);
      this.TLS_card_violin_no = this.TLS_card_violin_no + 1
    },
    remove_son_violin(i){
      this.TLS_card_violin = this.TLS_card_violin.filter(item => item !== i);
    },
    add_immune(){
      this.TLS_card_immune.push(this.TLS_card_immune_no);
      this.TLS_card_immune_no = this.TLS_card_immune_no + 1
    },
    remove_son_immune(i){
      this.TLS_card_immune = this.TLS_card_immune.filter(item => item !== i);
    },
  }
}
</script>

<style scoped>

.RadioBox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  /*padding: 20px;*/
  padding-left: 20px;
  margin: 20px auto;
}

.RadioItem1 {
  /*display: flex;*/
  width: 160px;
  margin: 0 10px 10px 0;
  /*align-items: center;*/
}

.RadioItem2 {
  /*display: flex;*/
  width: 140px;
  margin: 0 10px 10px 0;
  /*align-items: center;*/
}

.fontClass{
  color: black;
  font-size:20px;
}
#PancCancer_TLS {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
}
#PancCancer_left_TLS{
  width: 40%;
  /*width: 900px;*/
  /*overflow-x: auto;*/
  /*overflow-y: auto;*/
  z-index: 0;
}

#PancCancer_right_TLS{
  /*margin-left: 1000px;*/
  /*height: 50%;*/
  width: 50%;
  flex: 1;
  /*overflow-x: auto;*/
  /*overflow-y: auto;*/
  /*z-index: 99;*/
}

.circle_btn{
  width: 100px;
  height: 100px;
  border-radius:50%;
  background-color: #FFFFFE;
  border: 1px solid #d5d5d5;
  margin: auto;
}
.circle_btn:hover{
  background-color: #dee0e3;
}
.circle_btn:hover span{
  color: blue;
}
</style>
